import { render, staticRenderFns } from "./ConsultoriaPage.vue?vue&type=template&id=66f7afda&scoped=true"
import script from "./ConsultoriaPage.vue?vue&type=script&lang=js"
export * from "./ConsultoriaPage.vue?vue&type=script&lang=js"
import style0 from "./ConsultoriaPage.vue?vue&type=style&index=0&id=66f7afda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f7afda",
  null
  
)

export default component.exports